import Vue from 'vue';
import DateTimeUtils from '@/utils/datetime';
import BaseProxy from './base-proxy';


/**
 * Class EInvoiceAccountProxy
 */
class EInvoiceAccountProxy extends BaseProxy {
  /**
   * Constructor.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/invoice-robotics-api/api', parameters);
  }

  getEInvoiceAccounts(options = {}) {
    return this.submit('post', `${this.endpoint}/get-einvoice-accounts`, null, options);
  }

  createEInvoiceAccount(einvoice) {
    const toast = {
      success: Vue.i18n.t('user.eAccountInvoiceCreated'),
      error: Vue.i18n.t('user.eAccountInvoiceCreatedError'),
    };
    return this.submit('post', `${this.endpoint}/create-einvoice-account`, einvoice, {
      toast,
    });
  }

  deleteEInvoiceAccount(id) {
    const toast = {
      success: Vue.i18n.t('user.eAccountInvoiceDeleted'),
      error: Vue.i18n.t('user.eAccountInvoiceDeletedError'),
    };
    return this.submit('post', `${this.endpoint}/delete-einvoice-account`, { id }, { toast });
  }

  activeEInvoiceAccount(id) {
    const toast = {
      success: Vue.i18n.t('user.eAccountInvoiceHasBeenActivated'),
    };
    return this.submit('post', `${this.endpoint}/active-einvoice-account`, { id }, { toast });
  }

  syncEInvoices(payload) {
    const toast = {
      success: Vue.i18n.t('user.eAccountHasBeenSync'),
    };
    return this.submit('post', `${this.endpoint}/synchronize-einvoice`, {
      from_date: DateTimeUtils.formatDate(payload, 'YYYY-MM-DD'),
    }, { toast });
  }
}

export default EInvoiceAccountProxy;



// WEBPACK FOOTER //
// ./src/store/proxies/e-invoice-account-proxy.js